import { NotifyHelper } from "../../../helpers/toast";
import { eAccDoiTuongKhongTinhHocPhiActionsObj } from "../../action-types/category/IDoiTuongKhongTinhHocPhiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const doiTuongKhongTinhHocPhiActions = {
  ...generateActions(
    eAccDoiTuongKhongTinhHocPhiActionsObj,
    "DOI_TUONG_KHONG_TINH_HOC_PHI",
  ),
  ...generateActionForKey(
    eAccDoiTuongKhongTinhHocPhiActionsObj,
    "DOI_TUONG_KHONG_TINH_HOC_PHI",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    },
  ),
  ...generateActionForKey(
    eAccDoiTuongKhongTinhHocPhiActionsObj,
    "DOI_TUONG_KHONG_TINH_HOC_PHI",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
  ...generateActionForKey(
    eAccDoiTuongKhongTinhHocPhiActionsObj,
    "DOI_TUONG_KHONG_TINH_HOC_PHI",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    },
  ),
  ...generateActionForKey(
    eAccDoiTuongKhongTinhHocPhiActionsObj,
    "DOI_TUONG_KHONG_TINH_HOC_PHI",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    },
  ),
};
